module.exports = __webpack_public_path__ + "static/media/everything.e8836096.jpg";